import { CSSProperties, ReactNode, useRef } from 'react';
import cx from 'classnames';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import styles from './SCSS/HintIcon.module.scss';
import greyHelpIcon from './images/pkp-help-icon-grey.svg';
import blueHelpIcon from './images/pkp-help-icon-blue.svg';
import { PopoverBody, PopoverHeader } from 'react-bootstrap';

interface Props {
  style?: CSSProperties;
  title?: string;
  hintText?: string;
  disabledImage?: string;
  enabledImage?: string;
  imgStyle?: CSSProperties;
  children?: ReactNode;
  id?: string;
  className?: string;
}

export const HintIcon = ({
  style,
  title,
  hintText,
  disabledImage,
  enabledImage,
  imgStyle,
  children,
  id,
  className,
}: Props): JSX.Element => {
  const iconRef = useRef(null);

  const HintPopover = (props: any) => {
    return (
      <Popover id='hint-popover' className={styles.hintPopover} {...props}>
        {title && <PopoverHeader>{title}</PopoverHeader>}
        <PopoverBody>{hintText || children}</PopoverBody>
      </Popover>
    );
  };

  return (
    <div className={cx(styles.hintIcon, className)} style={style} id={id}>
      <OverlayTrigger
        trigger='click'
        overlay={HintPopover}
        target={iconRef.current ? iconRef.current : undefined}
        rootClose
        // onHide={() => {
        //   return;
        // }}
      >
        {disabledImage ? (
          <img
            alt='Disabled'
            src={disabledImage}
            style={imgStyle && imgStyle}
            ref={iconRef}
            onClick={stopPropagateRootClose}
          />
        ) : (
          <img
            alt='Help'
            src={greyHelpIcon}
            style={imgStyle && imgStyle}
            ref={iconRef}
            onClick={stopPropagateRootClose}
          />
        )}
      </OverlayTrigger>
      <OverlayTrigger
        trigger='click'
        overlay={HintPopover}
        target={iconRef.current ? iconRef.current : undefined}
        rootClose
        // onHide={() => {
        //   return;
        // }}
      >
        {enabledImage ? (
          <img
            alt='Enabled'
            src={enabledImage}
            style={imgStyle && imgStyle}
            ref={iconRef}
            onClick={stopPropagateRootClose}
          />
        ) : (
          <img
            alt='Help'
            src={blueHelpIcon}
            style={imgStyle && imgStyle}
            ref={iconRef}
            onClick={stopPropagateRootClose}
          />
        )}
      </OverlayTrigger>
    </div>
  );

  //
  // When popover is used within a Modal, the click
  // message which is triggered when clicking
  // on the icon also causes rootClose to activate
  // immediately. We use this function to prevent
  // the propagation on the initial click
  //
  function stopPropagateRootClose(e: {
    stopPropagation: () => void;
    preventDefault: () => void;
    nativeEvent: { stopImmediatePropagation: () => void };
  }) {
    e.stopPropagation();
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
  }
};
